module.exports = __webpack_public_path__ + "static/img/back-bg.97b5c10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/back-bg.png
// module id = fZpR
// module chunks = 1